export default "__VITE_ASSET__CxglRrU3__"